module.exports = __webpack_public_path__ + "img/Denmark_Hall_-_ADT-t-26303-019.bfb68017.jpg";